import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#00E676]/20 py-10 px-4" data-id="element-188">
      <div className="max-w-3xl mx-auto text-center" data-id="element-189">
        <div className="text-[#00E676] text-2xl font-black tracking-widest mb-4" data-id="element-190">
          🧬 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-191">
          El sistema de cátedra N°1 para docentes de Biología de secundaria en
          Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-192">
          Porque enseñar Biología no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-193">
          <span data-id="element-194">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-195">•</span>
          <span data-id="element-196">📲 @profepack</span>
        </div>

        <div className="h-px bg-[#00E676]/20 mb-6" data-id="element-197" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-198">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs" data-id="element-199">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}